module.exports = "https://cdn.realtymogul.com/static/media/Img_hero_investOpts.4aabd0c3.jpg";